import { createModel } from '@rematch/core';

const app = createModel({
  state: {
    authenticatedUser: null,
    documentTitle: ''
  },
  reducers: {
    setAuthenticatedUser: (state, authenticatedUser) => ({
      ...state,
      authenticatedUser
    }),
    setDocumentTitle: (state, documentTitle) => ({
      ...state,
      documentTitle
    })
  },
  effects: (dispatch: any) => ({
  })
});

export default app;
